import { render, staticRenderFns } from "./DesignFormRouteModal.vue?vue&type=template&id=3f53ba12&scoped=true&"
import script from "./DesignFormRouteModal.vue?vue&type=script&lang=js&"
export * from "./DesignFormRouteModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f53ba12",
  null
  
)

export default component.exports